import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import networks_gen_2_pro from '@devices/settings/device_settings/networks_gen_2_pro.js';
import virtual_components_pro_devices from '@devices/settings/device_settings/virtual_components_pro_devices.js';
import safety_gen_2_auto_recovery_under_voltage from '@devices/settings/device_settings/safety_gen_2_auto_recovery_under_voltage.js';
import app_setting_pm_gen_2 from '@devices/settings/device_settings/app_setting_pm_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import settings_gen_2 from '@devices/settings/device_settings/settings_gen_2.js';
import addon_sensors, { addon_pro_devices } from '@devices/settings/device_settings/addon_sensors';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';
import { createSceneCapabilities } from '@components/Flows/sceneCapabilities/index.js';

export default {
	name: 'ShellyPro1PM',
	friendly_name: 'Pro 1 PM',
	family: 'relay',
	isPM: true,
	addons: addon_pro_devices,
	modes: {
		relay: {
			sceneCapabilities: createSceneCapabilities({ template: 'single_relay' }),
			channels: 1,
			notifications: [
				'offline',
				'device_problem',
				'overpower',
				'overvoltage',
				'forgotten_lights',
				'overtemperature',
			],
			settings: [
				timer_gen_2,
				schedule_gen_2,
				webhooks_gen_2,
				addon_sensors,
				scripts_gen_2,
				networks_gen_2_pro,
				bluetooth_gen_2,
				virtual_components_pro_devices,
				safety_gen_2_auto_recovery_under_voltage,
				app_setting_pm_gen_2,
				share,
				settings_gen_2,
			],
		},
	},
};
